import { jsx } from "react/jsx-runtime";
import { useColorScheme, ColorSchemeContext, useClassName } from "@contember/react-utils";
import { stateDataAttributes, contentThemeClassName, controlsThemeClassName, colorSchemeClassName } from "@contember/utilities";
import { mergeProps } from "react-aria";
const defaultProps = {
  displayContents: true,
  overridesLucideIcons: true,
  scheme: "system",
  themeContent: "default",
  themeControls: "accent",
  transparent: true,
  suppressFocusRing: true
};
const StyleProvider = ({ children, ...props }) => {
  const { scheme, themeContent, themeControls, ...state } = mergeProps(defaultProps, props);
  const colorScheme = useColorScheme();
  return /* @__PURE__ */ jsx(ColorSchemeContext.Provider, { value: scheme ?? colorScheme ?? "system", children: /* @__PURE__ */ jsx(
    "div",
    {
      ...stateDataAttributes(state),
      className: useClassName("root", [
        contentThemeClassName(themeContent),
        controlsThemeClassName(themeControls),
        colorSchemeClassName(scheme)
      ]),
      children
    }
  ) });
};
StyleProvider.displayName = "Interface.StyleProvider";
export {
  StyleProvider
};
//# sourceMappingURL=StyleProvider.js.map
